module.exports = __webpack_public_path__ + "img/Bear19.a22e88ff.jpg";